<template>
  <div>
    <!--弹出框-->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm"
      style="height: 100%">
      <el-dialog title="淤地坝基本信息" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose"
        :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
        <el-row>
          <el-col :span="6">
            <el-form-item type="type" label="省" prop="ydbSheng">
              <el-input type="type" placeholder="省" class="from-el-input" v-model.trim="ruleForm.ydbSheng" :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="市" class="from-el-input-line" prop="ydbShi">
              <el-input type="type" placeholder="市" class="from-el-input" v-model.trim="ruleForm.ydbShi" :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="县" class="from-el-input-line" prop="ydbXian">
              <el-input type="type" placeholder="县" class="from-el-input" v-model.trim="ruleForm.ydbXian" :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="乡" class="from-el-input-line" prop="ydbXiang">
              <el-input type="type" placeholder="乡" class="from-el-input" v-model.trim="ruleForm.ydbXiang" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="村" class="from-el-input-line" prop="ydbCun">
              <el-input type="type" placeholder="村" class="from-el-input" v-model.trim="ruleForm.ydbCun" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="淤地坝名称" class="from-el-input-line" prop="ydbName">
              <el-input type="type" placeholder="淤地坝名称" class="from-el-input" v-model.trim="ruleForm.ydbName" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="淤地坝编码" class="from-el-input-line" prop="ydbCode">
              <el-input type="type" placeholder="淤地坝编码" class="from-el-input" v-model.trim="ruleForm.ydbCode" :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="淤地坝类型" class="from-el-input-line" prop="ydbSfwggb">
              <el-select v-model.trim="ruleForm.ydbSfwggb" placeholder="请选择类型" :disabled="nobj">
                <el-option label="大型坝" value="大型"></el-option>
                <el-option label="中型坝" value="中型"></el-option>
                <el-option label="小型坝" value="小型"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="枢纽组成" class="from-el-input-line" prop="ydbSnzc">
              <el-input type="type" placeholder="枢纽组成" class="from-el-input" v-model.trim="ruleForm.ydbSnzc" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="所在流域" class="from-el-input-line" prop="ydbSszl">
              <el-input type="type" placeholder="所在流域" class="from-el-input" v-model.trim="ruleForm.ydbSszl" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="建成年代" class="from-el-input-line" prop="ydbJcnd">
              <el-input type="type" placeholder="建成年代" class="from-el-input" v-model.trim="ruleForm.ydbJcnd" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="控制面积(km²)" class="from-el-input-line" prop="ydbKzmj">
              <el-input type="number" placeholder="控制面积(km²)" class="from-el-input" v-model.trim="ruleForm.ydbKzmj" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="坝高(m)" class="from-el-input-line" prop="ydbBaGao">
              <el-input type="number" placeholder="坝高(m)" class="from-el-input" v-model.trim="ruleForm.ydbBaGao" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="坝顶长(m)" class="from-el-input-line" prop="ydbBdcd">
              <el-input type="number" placeholder="坝顶长(m)" class="from-el-input" v-model.trim="ruleForm.ydbBdcd" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="总库容(万m³)" class="from-el-input-line" prop="ydbZkr">
              <el-input type="number" placeholder="总库容(万m³)" class="from-el-input" v-model.trim="ruleForm.ydbZkr" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="滞洪库容(万m³)" class="from-el-input-line" prop="ydbDhkr">
              <el-input type="number" placeholder="滞洪库容(万m³)" class="from-el-input" v-model.trim="ruleForm.ydbDhkr" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="设计淤积库容(万m³)" class="from-el-input-line" prop="ydbSjyjkr">
              <el-input type="number" placeholder="设计淤积库容(万m³)" class="from-el-input" v-model.trim="ruleForm.ydbSjyjkr" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="已淤库容(万m³)" class="from-el-input-line" prop="ydbYykr">
              <el-input type="number" placeholder="已淤库容(万m³)" class="from-el-input" v-model.trim="ruleForm.ydbYykr" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="设计淤地面积(hm²)" class="from-el-input-line" prop="ydbSjyjmj">
              <el-input type="number" placeholder="设计淤地面积(hm²)" class="from-el-input" v-model.trim="ruleForm.ydbSjyjmj" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="已淤地面积(hm²)" class="from-el-input-line" prop="ydbYyjmj">
              <el-input type="number" placeholder="已淤地面积(hm²)" class="from-el-input" v-model.trim="ruleForm.ydbYyjmj" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="经度" class="from-el-input-line" prop="ydbJingDu">
              <el-input type="number" placeholder="经度" class="from-el-input" v-model.trim="ruleForm.ydbJingDu" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="纬度" class="from-el-input-line" prop="ydbWeiDu">
              <el-input type="number" placeholder="纬度" class="from-el-input" v-model.trim="ruleForm.ydbWeiDu" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否改建" class="from-el-input-line" prop="ydbSfgj">
              <el-select v-model.trim="ruleForm.ydbSfgj" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否除险加固" class="from-el-input-line" prop="ydbSfcxjg">
              <el-select v-model.trim="ruleForm.ydbSfcxjg" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否老旧坝" class="from-el-input-line" prop="ydbSfljb">
              <el-select v-model.trim="ruleForm.ydbSfljb" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="病险数量统计" class="from-el-input-line" prop="ydbBxsltj">
              <!-- <el-select v-model.trim="ruleForm.ydbBxsltj" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select> -->
              <el-input type="number" placeholder="病险数量统计" class="from-el-input" v-model.trim="ruleForm.ydbBxsltj" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否需改造提升" class="from-el-input-line" prop="ydbSfxygzsj">
              <el-select v-model.trim="ruleForm.ydbSfxygzsj" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否需蓄水利用" class="from-el-input-line" prop="ydbSfxyxsly">
              <el-select v-model.trim="ruleForm.ydbSfxyxsly" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否被占用或改变用途" class="from-el-input-line" prop="ydbSfbzyhgbyt">
              <el-select v-model.trim="ruleForm.ydbSfbzyhgbyt" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item type="type" label="影响人数" class="from-el-input-line" prop="ydbYxrs">
              <el-input type="number" placeholder="影响人数" class="from-el-input" v-model.trim="ruleForm.ydbYxrs" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item type="type" label="是否下游有人" class="from-el-input-line" prop="ydbSfxyyr">
              <el-select v-model.trim="ruleForm.ydbSfxyyr" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="重要设施" class="from-el-input-line" prop="ydbZyss">
              <el-input type="type" placeholder="重要设施" class="from-el-input" v-model.trim="ruleForm.ydbZyss" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="监控设施" class="from-el-input-line" prop="ydbJkss">
              <el-input type="type" placeholder="监控设施" class="from-el-input" v-model.trim="ruleForm.ydbJkss" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="管理责任主体" class="from-el-input-line" prop="ydbGlzrzt">
              <el-input type="type" placeholder="管理责任主体" class="from-el-input" v-model.trim="ruleForm.ydbGlzrzt" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="管护报酬" class="from-el-input-line" prop="ydbYwghbc">
              <el-input type="type" placeholder="管护报酬" class="from-el-input" v-model.trim="ruleForm.ydbYwghbc" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="其他问题" class="from-el-input-line" prop="ydbQtwtsm">
              <el-input type="type" placeholder="其他问题" class="from-el-input" v-model.trim="ruleForm.ydbQtwtsm" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">坝体病险情况</p>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="裂缝" class="from-el-input-line" prop="ydbBtlf">
              <el-select v-model.trim="ruleForm.ydbBtlf" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="滑坡坍塌" class="from-el-input-line" prop="ydbBthptt">
              <el-select v-model.trim="ruleForm.ydbBthptt" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="冲缺冲沟" class="from-el-input-line" prop="ydbBtcqcg">
              <el-select v-model.trim="ruleForm.ydbBtcqcg" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="管涌、渗漏" class="from-el-input-line" prop="ydbBtgysl">
              <el-select v-model.trim="ruleForm.ydbBtgysl" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">放水建筑物病险情况</p>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="卧管、竖井" class="from-el-input-line" prop="ybdFsjzwwgsj">
              <el-select v-model.trim="ruleForm.ybdFsjzwwgsj" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="涵洞、涵管" class="from-el-input-line" prop="ydbFsjzwhdhg">
              <el-select v-model.trim="ruleForm.ydbFsjzwhdhg" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="明渠" class="from-el-input-line" prop="ydbFsjzwmq">
              <el-select v-model.trim="ruleForm.ydbFsjzwmq" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">泄水建筑物病险情况</p>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="损毁" class="from-el-input-line" prop="ydbXsjzwmq">
              <el-select v-model.trim="ruleForm.ydbXsjzwmq" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="淘刷、悬空" class="from-el-input-line" prop="ydbXsjzwtsxk">
              <el-select v-model.trim="ruleForm.ydbXsjzwtsxk" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="其他" class="from-el-input-line" prop="ydbXsjzwqt">
              <el-select v-model.trim="ruleForm.ydbXsjzwqt" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">其他安全隐患</p>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="道路不通" class="from-el-input-line" prop="ydbDlbt">
              <el-select v-model.trim="ruleForm.ydbDlbt" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="两岸边坡不稳定" class="from-el-input-line" prop="ydbLabpbwd">
              <el-select v-model.trim="ruleForm.ydbLabpbwd" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">2024年中型以上淤地坝淤积专项调查基本数据</p>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="坝控面积(km²)" class="from-el-input-line" prop="ydbBkmj">
              <el-input type="type" placeholder="坝控面积(km²)" class="from-el-input" v-model.trim="ruleForm.ydbBkmj" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">淤积调查地理坐标(采用CGCS2000国家大地坐标系)</p>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="经度" class="from-el-input-line" prop="ydbYjdcjd">
              <el-input type="type" placeholder="经度" class="from-el-input" v-model.trim="ruleForm.ydbYjdcjd" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="纬度" class="from-el-input-line" prop="ydbYjdcwd">
              <el-input type="type" placeholder="纬度" class="from-el-input" v-model.trim="ruleForm.ydbYjdcwd" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">基于卫星遥感/无人机影像获取的指标成果</p>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="数据来源" class="from-el-input-line" prop="ydbYxsjly">
              <el-select v-model.trim="ruleForm.ydbYxsjly" placeholder="请选择数据来源" :disabled="nobj">
                <el-option label="卫星遥感影像" :value="0"></el-option>
                <el-option label="无人机影像" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="高程基准" class="from-el-input-line" prop="ydbYxgcjz">
              <el-select v-model.trim="ruleForm.ydbYxgcjz" placeholder="请选择高程基准" :disabled="nobj">
                <el-option label="大地高程" :value="0"></el-option>
                <el-option label="85高程" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="已淤面积（h㎡）（无水坝淤积面积/有水坝水面或水面与出露淤积面整体面积）" placement="top">
            <el-form-item type="type" label="已淤面积(h㎡)" class="from-el-input-line" prop="ydbYxyymj">
              <el-input type="type" placeholder="已淤面积(h㎡)" class="from-el-input" v-model.trim="ruleForm.ydbYxyymj" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="无水坝淤积面/有水坝水面或水面与出露淤积面整体到坝顶的容积（万m³）（不含水体体积）" placement="top">
              <el-form-item type="type" label="整体到坝顶的容积(万m³)" class="from-el-input-line" prop="ydbYxsykr">
                <el-input type="type" placeholder="整体到坝顶的容积(万m³)" class="from-el-input" v-model.trim="ruleForm.ydbYxsykr" :disabled="nobj">
                </el-input>
              </el-form-item>
            </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="已淤库容(万m³)(不含水体体积)" placement="top">
            <el-form-item type="type" label="已淤库容(万m³)" class="from-el-input-line" prop="ydbYxyykr">
              <el-input type="type" placeholder="已淤库容(万m³)" class="from-el-input" v-model.trim="ruleForm.ydbYxyykr" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="水体体积(万m³)(有水淤地坝的水的体积)" placement="top">
            <el-form-item type="type" label="水体体积(万m³)" class="from-el-input-line" prop="ydbYxxskr">
              <el-input type="type" placeholder="请输入水体体积" class="from-el-input" v-model.trim="ruleForm.ydbYxxskr" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="坝顶高程(m)(坝顶平均高程值)" placement="top">
            <el-form-item type="type" label="坝顶高程(m)" class="from-el-input-line" prop="ydbYxbdgc">
              <el-input type="type" placeholder="坝顶高程(m)" class="from-el-input" v-model.trim="ruleForm.ydbYxbdgc" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="无水坝淤积面平均高程/有水坝水面或水面与出露淤积面整体平均高程（m）" placement="top">
            <el-form-item type="type" label="淤积整体平均高程(m)" class="from-el-input-line" prop="ydbYxyjgc">
              <el-input type="type" placeholder="淤积整体平均高程(m)" class="from-el-input" v-model.trim="ruleForm.ydbYxyjgc" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="泄洪设施高程(m)(泄洪设施进口段横断面平均高程值)" placement="top">
            <el-form-item type="type" label="泄洪设施高程(m)" class="from-el-input-line" prop="ydbYxxhssgc">
              <el-input type="type" placeholder="泄洪设施高程(m)" class="from-el-input" v-model.trim="ruleForm.ydbYxxhssgc" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="坝体背水面坝脚高程(m)(坝体背水面与下游连接处沟底高程)" placement="top">
            <el-form-item type="type" label="坝体背水面坝脚高程(m)" class="from-el-input-line" prop="ydbYxbtbsmbjgc">
              <el-input type="type" placeholder="坝体背水面坝脚高程(m)" class="from-el-input" v-model.trim="ruleForm.ydbYxbtbsmbjgc" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="数据计算人员姓名" class="from-el-input-line" prop="ydbYxsjjsryxm">
              <el-input type="type" placeholder="数据计算人员姓名" class="from-el-input" v-model.trim="ruleForm.ydbYxsjjsryxm" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="数据计算人员联系方式" class="from-el-input-line" prop="ydbYxsjjsrylxfs">
              <el-input type="type" placeholder="数据计算人员联系方式" class="from-el-input" v-model.trim="ruleForm.ydbYxsjjsrylxfs" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">RTK/无人船声呐技术实测获取的指标成果</p>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="数据来源" class="from-el-input-line" prop="ydbScsjly">
              <el-select v-model="ruleForm.ydbScsjly" placeholder="请选择数据来源" :disabled="nobj">
                <el-option label="RTK测量" :value="0"></el-option>
                <el-option label="RTK测量辅助无人船声呐技术" :value="1"></el-option>
                <el-option label="无人机航测辅助无人船声呐技术" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="高程基准" class="from-el-input-line" prop="ydbScgcjz">
              <el-select v-model="ruleForm.ydbScgcjz" placeholder="请选择高程基准" :disabled="nobj" filterable @filter-change="handleFilter">
                <el-option label="大地高程" :value="0"></el-option>
                <el-option label="85高程" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="坝顶高程(m)(坝顶各测点高程平均值)" placement="top">
            <el-form-item type="type" label="坝顶高程(m)" class="from-el-input-line" prop="ydbScbtgc">
              <el-input type="type" placeholder="坝顶高程(m)" class="from-el-input" v-model.trim="ruleForm.ydbScbtgc" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="无水坝淤积面各测点平均高程/有水坝水面或水面与出露淤积面整体各测点平均高程（m）" placement="top">
            <el-form-item type="type" label="各测点平均高程(m)" class="from-el-input-line" prop="ydbScyjgc">
              <el-input type="type" placeholder="各测点平均高程(m)" class="from-el-input" v-model.trim="ruleForm.ydbScyjgc" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="水体深度(m)(有水淤地坝水深平均值)" placement="top">
            <el-form-item type="type" label="水体深度(m)" class="from-el-input-line" prop="ydbScstsd">
              <el-input type="type" placeholder="水体深度(m)" class="from-el-input" v-model.trim="ruleForm.ydbScstsd" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="泄洪设施高程(m)(泄洪设施进口段各测点平均高程值)" placement="top">
            <el-form-item type="type" label="泄洪设施高程(m)" class="from-el-input-line" prop="ydbScxhssgd">
              <el-input type="type" placeholder="泄洪设施高程(m)" class="from-el-input" v-model.trim="ruleForm.ydbScxhssgd" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-tooltip item custom-tooltip effect="white" content="坝体背水面坝脚高程(m)(坝体背水面与下游连接处沟底测点高程平均值)" placement="top">
            <el-form-item type="type" label="坝体背水面坝脚高程(m)" class="from-el-input-line" prop="ydbScbtbsmbjgc">
              <el-input type="type" placeholder="坝体背水面坝脚高程(m)" class="from-el-input" v-model.trim="ruleForm.ydbScbtbsmbjgc" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-tooltip>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="高程采集人员姓名" class="from-el-input-line" prop="ydbScgccjryxm">
              <el-input type="type" placeholder="高程采集人员姓名" class="from-el-input" v-model.trim="ruleForm.ydbScgccjryxm" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="高程采集人员联系方式" class="from-el-input-line" prop="ydbScgccjrylxfs">
              <el-input type="type" placeholder="高程采集人员联系方式" class="from-el-input" v-model.trim="ruleForm.ydbScgccjrylxfs" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="高程采集时间" class="from-el-input-line" prop="ydbScgccjsj">
              <el-date-picker
              v-model.trim="ruleForm.ydbScgccjsj"
              type="date"
              placeholder="选择日期"
              :disabled="nobj"
              class="custom-date-picker"
            ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否16788数据" class="from-el-input-line" prop="ydbSf16788sj">
              <el-select v-model.trim="ruleForm.ydbSf16788sj" placeholder="请选择是否" :disabled="true">
                <el-option label="否" :value="0"></el-option>
                <el-option label="是" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="特殊情况淤地坝" class="from-el-input-line" prop="ydbTsqkydb">
              <el-select v-model.trim="ruleForm.ydbTsqkydb" placeholder="请选择" :disabled="nobj">
                <el-option label="淤地坝损毁" value="0"></el-option>
                <el-option label="位置信息错误找不见坝" value="1"></el-option>
                <el-option label="位置信息重复找不见坝" value="2"></el-option>
                <el-option label="人为活动占用" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="淤积情况" class="from-el-input-line" prop="ydbYjqk">
              <el-select v-model.trim="ruleForm.ydbYjqk" placeholder="请选择" :disabled="nobj" filterable @filter-change="handleFilter">
                <el-option label="完全淤平" :value="0"></el-option>
                <el-option label="接近淤满" :value="1"></el-option>
                <el-option label="未淤满" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item type="type" label="上下游原始沟底高程无法获取" class="from-el-input-line" prop="ydbSxyysgdwfhq">
              <el-select v-model="ruleForm.ydbSxyysgdwfhq" placeholder="请选择" :disabled="nobj">
                <el-option label="坝系，采用坝高已修正" :value="0"></el-option>
                <el-option label="坝系，无法修正" :value="1"></el-option>
                <el-option label="其他，采用坝高已修正" :value="2"></el-option>
                <el-option label="其他，无法修正" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item type="type" label="边坡坡度是否准确获取" class="from-el-input-line" prop="ydbBppdsfzqhq">
              <el-select v-model.trim="ruleForm.ydbBppdsfzqhq" placeholder="请选择是否" :disabled="nobj" filterable @filter-change="handleFilter">
                <el-option label="否" :value="1"></el-option>
                <el-option label="是" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="备注" class="from-el-input-line" prop="remark">
              <el-input type="type" placeholder="备注" class="from-el-input" v-model.trim="ruleForm.remark" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer" v-if="states=='bj'">
          <el-form-item>
            <el-button round @click="empty()" type="warning">取消</el-button>
            <el-button round type="primary" @click="deteRmine('ruleForm')">提交审核</el-button>
          </el-form-item>
        </span>
      </el-dialog>
    </el-form>
    <!--弹出框-->
  </div>
</template>

<script>
  import {
    preApproveYdb
  } from '@/api/api.js'
  export default {
    props: {
      mystate: Array
    },
    data() {
      return {
        dialogVisible: true,
        row: null,
        states: '',
        nobj: false,
        ruleForm: {
          id: '',
          userId: '',
          ydbSheng: '',
          ydbShengCode: '',
          ydbShi: '',
          ydbShiCode: '',
          ydbXian: '',
          ydbXianCode: '',
          ydbXiang: '',
          ydbCun: '',
          ydbName: '',
          ydbCode: '',
          ydbSfwggb: '',
          ydbSnzc: '',
          ydbSszl: '',
          ydbJcnd: '',
          ydbKzmj: '',
          ydbBaGao: '',
          ydbBdcd: '',
          ydbZkr: '',
          ydbDhkr: '',
          ydbSjyjkr: '',
          ydbYykr: '',
          ydbSjyjmj: '',
          ydbYyjmj: '',
          ydbJingDu: '',
          ydbWeiDu: '',
          ydbSfgj: '',
          ydbSfcxjg: '',
          ydbSfljb: '',
          ydbBxsltj: '',
          ydbSfxygzsj: '',
          ydbSfxyxsly: '',
          ydbSfbzyhgbyt: '',
          ydbYxrs: '',
          ydbZyss: '',
          ydbJkss: '',
          ydbGlzrzt: '',
          ydbYwghbc: '',
          ydbQtwtsm: '',
          ydbBtlf: '',
          ydbBthptt: '',
          ydbBtcqcg: '',
          ydbBtgysl: '',
          ybdFsjzwwgsj: '',
          ydbFsjzwhdhg: '',
          ydbFsjzwmq: '',
          ydbXsjzwmq: '',
          ydbXsjzwtsxk: '',
          ydbXsjzwqt: '',
          ydbDlbt: '',
          ydbLabpbwd: '',
          ydbLx: '编辑',
          ydbBkmj: '',
          ydbYjdcjd: '',
          ydbYjdcwd: '',
          ydbYxsjly: '',
          ydbYxgcjz: '',
          ydbYxyymj: '',
          ydbYxsykr: '',
          ydbYxyykr: '',
          ydbYxxskr: '',
          ydbYxbdgc: '',
          ydbYxyjgc: '',
          ydbYxxhssgc: '',
          ydbYxbtbsmbjgc: '',
          ydbYxsjjsryxm: '',
          ydbYxsjjsrylxfs: '',
          ydbScsjly: '',
          ydbScgcjz: '',
          ydbScbtgc: '',
          ydbScyjgc: '',
          ydbScstsd: '',
          ydbScxhssgd: '',
          ydbScbtbsmbjgc: '',
          ydbScgccjryxm: '',
          ydbScgccjrylxfs: '',
          ydbScgccjsj: '',
          ydbSf16788sj: '',
          ydbSfxyyr: 0,
          ydbTsqkydb: '',
          ydbYjqk: '',
         // ydbSxyysgdwfhq: '',
          ydbBppdsfzqhq: '',
          remark: ''
        },
        rules: {
          ydbSheng: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbShi: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbXian: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbXiang: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbCun: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbName: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbCode: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSfwggb: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSnzc: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSszl: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbJcnd: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbKzmj: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbBaGao: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbBdcd: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbZkr: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbDhkr: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSjyjkr: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYykr: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSjyjmj: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYyjmj: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbJingDu: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbWeiDu: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSfgj: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSfcxjg: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSfljb: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSfxyyr: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbBxsltj: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSfxygzsj: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSfxyxsly: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSfbzyhgbyt: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxrs: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbZyss: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbJkss: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbGlzrzt: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYwghbc: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbQtwtsm: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbBtlf: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbBthptt: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbBtcqcg: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbBtgysl: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ybdFsjzwwgsj: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbFsjzwhdhg: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbFsjzwmq: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbXsjzwmq: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbXsjzwtsxk: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbXsjzwqt: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbDlbt: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbLabpbwd: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbBkmj: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYjdcjd: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYjdcwd: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxsjly: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxgcjz: [{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxyymj:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxsykr:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxyykr:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxxskr:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxbdgc:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxyjgc:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxxhssgc:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxbtbsmbjgc:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxsjjsryxm:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYxsjjsrylxfs:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbScsjly:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbScgcjz:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbScbtgc:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbScyjgc:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbScstsd:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbScxhssgd:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbScbtbsmbjgc:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbScgccjryxm:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbScgccjrylxfs:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbScgccjsj:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbSf16788sj:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbTsqkydb:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbYjqk:[{required: false,message: "请输入必填项",trigger: "blur"}],
         // ydbSxyysgdwfhq:[{required: false,message: "请输入必填项",trigger: "blur"}],
          ydbBppdsfzqhq:[{required: false,message: "请输入必填项",trigger: "blur"}],
          remark:[{required: false,message: "请输入必填项",trigger: "blur"}]
        },
      };
    },
    created() {
      //初始化数据
    },
    components: {},
    methods: {
      handleYdbTsqkydbValue() {//特殊情况淤地坝处理 
        const validValues = ['0', '1', '2', '3'];
        if (!validValues.includes(this.ruleForm.ydbTsqkydb)) {
          this.ruleForm.ydbTsqkydb = '';
        }
      },
      handleYdbSxyysgdwfhqValue() {//上下游原始沟底高程无法获取处理
        const validValues = ['0', '1', '2', '3'];
        if (!validValues.includes(this.ruleForm.ydbSxyysgdwfhq)) {
          this.ruleForm.ydbSxyysgdwfhq = '';
        }
      },
      // handleYdbScgcjzValue() {//高程基准处理
      //   const validValues = ['0', '1'];
      //   if (!validValues.includes(this.ruleForm.ydbScgcjz)) {
      //     this.ruleForm.ydbScgcjz = '';
      //   }
      // },
      deteRmine(formName) {
        let _this = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let arr = [];
            arr.push(this.ruleForm);
            preApproveYdb(arr).then((res) => {
              if (res.code == 200) {
                this.$notify({
                  title: "提示",
                  message: "提交审核成功！",
                  type: "success",
                });
              } else {
                this.$notify({
                  title: "提示",
                  message: res.message,
                  type: "error",
                });
              }
            });
            this.$emit('bjadddata', {
              dialogVisible: this.dialogVisible
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      empty() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.handleYdbTsqkydbValue();
        this.handleYdbSxyysgdwfhqValue();
        //this.handleYdbScgcjzValue();
      });
      this.row = this.mystate[1];
      this.states = this.mystate[0];
      //初始化
      if (this.states == 'ck') {
        this.nobj = true;
        if (this.row.modifyFiled && this.row.modifyFiled.length!=0) {
          for (let i=0; i<this.row.modifyFiled.length; i++) {
            let field = this.row.modifyFiled[i].field;
            if (this.rules[field]) {
              this.rules[field][0].required = true;
            }
          }
        }
      }
      if (this.states == 'bj') {
        this.rules.ydbSheng[0].required = true;
        this.rules.ydbShi[0].required = true;
        this.rules.ydbXian[0].required = true;
        this.rules.ydbXiang[0].required = true;
        this.rules.ydbCun[0].required = true;
        this.rules.ydbName[0].required = true;
        this.rules.ydbCode[0].required = true;
        this.rules.ydbSfwggb[0].required = true;
        this.rules.ydbSszl[0].required = true;
        this.rules.ydbZkr[0].required = true;
      }
      this.ruleForm.id = this.row.id;
      this.ruleForm.userId = this.row.userId;
      this.ruleForm.ydbSheng = this.row.ydbSheng;
      this.ruleForm.ydbShengCode = this.row.ydbShengCode;
      this.ruleForm.ydbShi = this.row.ydbShi;
      this.ruleForm.ydbShiCode = this.row.ydbShiCode;
      this.ruleForm.ydbXian = this.row.ydbXian;
      this.ruleForm.ydbXianCode = this.row.ydbXianCode;
      this.ruleForm.ydbXiang = this.row.ydbXiang;
      this.ruleForm.ydbCun = this.row.ydbCun;
      this.ruleForm.ydbName = this.row.ydbName;
      this.ruleForm.ydbCode = this.row.ydbCode;
      this.ruleForm.ydbSfwggb = this.row.ydbSfwggb;
      this.ruleForm.ydbSnzc = this.row.ydbSnzc;
      this.ruleForm.ydbSszl = this.row.ydbSszl;
      this.ruleForm.ydbJcnd = this.row.ydbJcnd;
      this.ruleForm.ydbKzmj = this.row.ydbKzmj;
      this.ruleForm.ydbBaGao = this.row.ydbBaGao;
      this.ruleForm.ydbBdcd = this.row.ydbBdcd;
      this.ruleForm.ydbZkr = this.row.ydbZkr;
      this.ruleForm.ydbDhkr = this.row.ydbDhkr;
      this.ruleForm.ydbSjyjkr = this.row.ydbSjyjkr;
      this.ruleForm.ydbYykr = this.row.ydbYykr;
      this.ruleForm.ydbSjyjmj = this.row.ydbSjyjmj;
      this.ruleForm.ydbYyjmj = this.row.ydbYyjmj;
      this.ruleForm.ydbJingDu = this.row.ydbJingDu;
      this.ruleForm.ydbWeiDu = this.row.ydbWeiDu;
      this.ruleForm.ydbSfgj = this.row.ydbSfgj;
      this.ruleForm.ydbSfcxjg = this.row.ydbSfcxjg;
      this.ruleForm.ydbSfljb = this.row.ydbSfljb;
      this.ruleForm.ydbSfxyyr = this.row.ydbSfxyyr;
      this.ruleForm.ydbBxsltj = this.row.ydbBxsltj;
      this.ruleForm.ydbSfxygzsj = this.row.ydbSfxygzsj;
      this.ruleForm.ydbSfxyxsly = this.row.ydbSfxyxsly;
      this.ruleForm.ydbSfbzyhgbyt = this.row.ydbSfbzyhgbyt;
      this.ruleForm.ydbYxrs = this.row.ydbYxrs;
      this.ruleForm.ydbZyss = this.row.ydbZyss;
      this.ruleForm.ydbJkss = this.row.ydbJkss;
      this.ruleForm.ydbGlzrzt = this.row.ydbGlzrzt;
      this.ruleForm.ydbYwghbc = this.row.ydbYwghbc;
      this.ruleForm.ydbQtwtsm = this.row.ydbQtwtsm;
      this.ruleForm.ydbBtlf = this.row.ydbBtlf;
      this.ruleForm.ydbBthptt = this.row.ydbBthptt;
      this.ruleForm.ydbBtcqcg = this.row.ydbBtcqcg;
      this.ruleForm.ydbBtgysl = this.row.ydbBtgysl;
      this.ruleForm.ybdFsjzwwgsj = this.row.ybdFsjzwwgsj;
      this.ruleForm.ydbFsjzwhdhg = this.row.ydbFsjzwhdhg;
      this.ruleForm.ydbFsjzwmq = this.row.ydbFsjzwmq;
      this.ruleForm.ydbXsjzwmq = this.row.ydbXsjzwmq;
      this.ruleForm.ydbXsjzwtsxk = this.row.ydbXsjzwtsxk;
      this.ruleForm.ydbXsjzwqt = this.row.ydbXsjzwqt;
      this.ruleForm.ydbDlbt = this.row.ydbDlbt;
      this.ruleForm.ydbLabpbwd = this.row.ydbLabpbwd;
      this.ruleForm.ydbBkmj = this.row.ydbBkmj;
      this.ruleForm.ydbYjdcjd = this.row.ydbYjdcjd;
      this.ruleForm.ydbYjdcwd = this.row.ydbYjdcwd;
      this.ruleForm.ydbYxsjly = this.row.ydbYxsjly;
      this.ruleForm.ydbYxgcjz = this.row.ydbYxgcjz;
      this.ruleForm.ydbYxyymj = this.row.ydbYxyymj;
      this.ruleForm.ydbYxsykr = this.row.ydbYxsykr;
      this.ruleForm.ydbYxyykr = this.row.ydbYxyykr;
      this.ruleForm.ydbYxxskr = this.row.ydbYxxskr;
      this.ruleForm.ydbYxbdgc = this.row.ydbYxbdgc;
      this.ruleForm.ydbYxyjgc = this.row.ydbYxyjgc;
      this.ruleForm.ydbYxxhssgc = this.row.ydbYxxhssgc;
      this.ruleForm.ydbYxbtbsmbjgc = this.row.ydbYxbtbsmbjgc;
      this.ruleForm.ydbYxsjjsryxm = this.row.ydbYxsjjsryxm;
      this.ruleForm.ydbYxsjjsrylxfs = this.row.ydbYxsjjsrylxfs;
      this.ruleForm.ydbScsjly = this.row.ydbScsjly;
      this.ruleForm.ydbScgcjz = this.row.ydbScgcjz;
      this.ruleForm.ydbScbtgc = this.row.ydbScbtgc;
      this.ruleForm.ydbScyjgc = this.row.ydbScyjgc;
      this.ruleForm.ydbScstsd = this.row.ydbScstsd;
      this.ruleForm.ydbScxhssgd = this.row.ydbScxhssgd;
      this.ruleForm.ydbScbtbsmbjgc = this.row.ydbScbtbsmbjgc;
      this.ruleForm.ydbScgccjryxm = this.row.ydbScgccjryxm;
      this.ruleForm.ydbScgccjrylxfs = this.row.ydbScgccjrylxfs;
      this.ruleForm.ydbScgccjsj = this.row.ydbScgccjsj;
      this.ruleForm.ydbSf16788sj = this.row.ydbSf16788sj;
      this.ruleForm.ydbTsqkydb = this.row.ydbTsqkydb;
      this.ruleForm.ydbYjqk = this.row.ydbYjqk;
     // this.ruleForm.ydbSxyysgdwfhq = this.row.ydbSxyysgdwfhq;
      this.ruleForm.ydbBppdsfzqhq = this.row.ydbBppdsfzqhq;
      this.ruleForm.remark = this.row.remark;
    },
    watch: {
      'ruleForm.ydbTsqkydb'(newValue) {
        this.handleYdbTsqkydbValue();
        //this.handleYdbSxyysgdwfhqValue();
      },
      'ruleForm.ydbScgcjz'(newValue){
        if (newValue === -1) {
          this.ruleForm.ydbScgcjz = null;
        }
      },
      'ruleForm.ydbScsjly'(newValue){
        if (newValue === -1) {
          this.ruleForm.ydbScsjly = null;
        }
      },
      'ruleForm.ydbYxsjly'(newValue){
        if (newValue === -1) {
          this.ruleForm.ydbYxsjly = null;
        }
      },
      'ruleForm.ydbYxgcjz'(newValue){
        if (newValue === -1) {
          this.ruleForm.ydbYxgcjz = null;
        }
      },
      'ruleForm.ydbYjqk'(newValue){
        if (newValue === -1) {
          this.ruleForm.ydbYjqk = null;
        }
      },
      'ruleForm.ydbBppdsfzqhq'(newValue){
        if (newValue === -1) {
          this.ruleForm.ydbBppdsfzqhq = null;
        }
      },
    },
  };
</script>

<style scoped="scoped">
  >>>.el-dialog {
    width: 1400px;
  }

  >>>.el-dialog__body {
    max-height: 600px;
    overflow: auto;
  }

  >>>.el-form-item__error {
    padding-top: 0;
  }

  >>>.el-input__inner {
    padding-right: 0;
  }

  .custom-tooltip {
  margin-top: 100px; 
}
  
.custom-date-picker .el-input__inner {
  width: 80%; /* 设置为所需长度 */
}
  
</style>
